module.exports = __webpack_public_path__ + "static/media/group_168.fd55c368.svg";